import React, { useState, useEffect, useRef, useCallback } from "react";
import "../assets/css/Gallery.css";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";

/* ---------- IMAGES ---------- */
import gallery1 from "../assets/images/gallery/Gallery (1).jpg";
import gallery2 from "../assets/images/gallery/Gallery (30).jpg";
import gallery3 from "../assets/images/gallery/Gallery (2).jpg";
import gallery4 from "../assets/images/gallery/Gallery (3).jpg";
import gallery5 from "../assets/images/gallery/Gallery (4).jpg";
import gallery6 from "../assets/images/gallery/Gallery (5).jpeg";
import gallery7 from "../assets/images/gallery/Gallery (6).jpeg";
import gallery8 from "../assets/images/gallery/Gallery (7).jpg";
import gallery9 from "../assets/images/gallery/Gallery (8).jpeg";
import gallery10 from "../assets/images/gallery/Gallery (9).jpeg";
import gallery11 from "../assets/images/gallery/galleryimac2026-1.jpg";
import gallery12 from "../assets/images/gallery/galleryimac2026-2.jpg";
import gallery13 from "../assets/images/gallery/galleryimac2026-3.jpg";
import gallery14 from "../assets/images/gallery/galleryimac2026-4.jpg";
import gallery15 from "../assets/images/gallery/galleryimac2026-5.jpg";
import gallery16 from "../assets/images/gallery/galleryimac2026-6.jpg";

/* ---------- VIDEO THUMBNAILS ---------- */
import card1 from "../assets/images/gallery/Video-Thumb.png";
import card2 from "../assets/images/gallery/Video-Thumb2.png";
import card3 from "../assets/images/gallery/Video-Thumb3.png";
import card4 from "../assets/images/gallery/Video-Thumb4.png";
import card5 from "../assets/images/gallery/Video-Thumb5.png";
import card6 from "../assets/images/gallery/Video-Thumb7.png";
import card7 from "../assets/images/gallery/Video-Thumb6.png";
import card8 from "../assets/images/gallery/roots-ix-d3.png";
import card9 from "../assets/images/gallery/roots-ix-d2.png";
import card10 from "../assets/images/gallery/roots-ix-d1.png";

/* ---------- VIDEOS ---------- */
import video1 from "../assets/Video/Gallery-Video (1).mp4";
import video2 from "../assets/Video/Gallery-Video (2).mp4";
import video3 from "../assets/Video/Gallery-Video (3).mp4";
import video4 from "../assets/Video/Gallery-Video (4).mp4";
import video5 from "../assets/Video/Gallery-Video (5).mp4";
import video6 from "../assets/Video/IMCAS-2026-REEL.mp4";
import video7 from "../assets/Video/Inside-IMCASWorld-Congress-Paris-2026.mp4";
import video8 from "../assets/Video/roots-IX-D3.mp4"; 
import video9 from "../assets/Video/roots-IX-D2.mp4";
import video10 from "../assets/Video/roots-IX-D1.mp4";

/* ---------- EVENT WISE GALLERY ---------- */
const galleryEvents = [
  {
    title: "IMCAS 2026 – Paris",
    images: [gallery11, gallery12, gallery13, gallery14, gallery15, gallery16]
  },
  {
    // title: "General",
    images: [gallery1, gallery2, gallery3],
  },
  {
    // title: "Dermatology Workshop",
    images: [gallery4, gallery5, gallery6],
  },
  {
    // title: "Clinical Training Program",
    images: [gallery7, gallery8, gallery9, gallery10],
  },
];

/* ---------- VIDEO CARDS ---------- */
const featureCards = [
  { img: card10, video: video10 },
  { img: card9, video: video9 },
  { img: card8, video: video8 },
  { img: card6, video: video6 },
  { img: card7, video: video7 },
  { img: card1, video: video1 },
  { img: card2, video: video2 },
  { img: card3, video: video3 },
  { img: card4, video: video4 },
  { img: card5, video: video5 },
];

export default function Gallery() {
  const [activeEventIndex, setActiveEventIndex] = useState(null);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [videoModalSrc, setVideoModalSrc] = useState(null);
  const [videoIndex, setVideoIndex] = useState(0);

  const videoRef = useRef(null);
  // const videosToShow = 4;
  const [videosToShow, setVideosToShow] = useState(4);

  useEffect(() => {
    const updateVideosToShow = () => {
      if (window.innerWidth <= 480) setVideosToShow(1);
      else if (window.innerWidth <= 768) setVideosToShow(2);
      else if (window.innerWidth <= 1024) setVideosToShow(3);
      else setVideosToShow(4);
    };

    updateVideosToShow();
    window.addEventListener("resize", updateVideosToShow);
    return () => window.removeEventListener("resize", updateVideosToShow);
  }, []);


  /* Lock body scroll */
  useEffect(() => {
    if (activeEventIndex !== null || videoModalSrc) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [activeEventIndex, videoModalSrc]);

  /* Keyboard Support */
  const onKeyDown = useCallback(
    (e) => {
      if (activeEventIndex !== null) {
        const images = galleryEvents[activeEventIndex].images;

        if (e.key === "Escape") setActiveEventIndex(null);
        if (e.key === "ArrowLeft")
          setLightboxIndex((prev) =>
            prev === 0 ? images.length - 1 : prev - 1
          );
        if (e.key === "ArrowRight")
          setLightboxIndex((prev) =>
            prev === images.length - 1 ? 0 : prev + 1
          );
      }

      if (videoModalSrc && e.key === "Escape") {
        setVideoModalSrc(null);
      }
    },
    [activeEventIndex, videoModalSrc]
  );

  useEffect(() => {
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [onKeyDown]);

  const openVideo = (src) => setVideoModalSrc(src);

  const closeVideo = () => {
    if (videoRef.current) videoRef.current.pause();
    setVideoModalSrc(null);
  };

  const makeVideoFullscreen = () => {
    const el = videoRef.current;
    if (!el) return;
    if (el.requestFullscreen) el.requestFullscreen();
  };

  return (
    <>
      <BreadcrumbSection
        title="Redefining Healthcare with Precision and Passion."
        breadcrumbItems={[{ label: "Home", to: "/" }]}
        backgroundImage={BredcrumpImage}
      />

      <section className="gallery-page">
        {/* HEADER */}
        <div className="gallery-header">
          <h2 className="gallery-heading">Gallery Of Excellence</h2>
          <p className="gallery-intro">
            We at Biopharmacieaa aim to enhance the understanding, management, and
            treatment of myriads of skin and hair concerns to deliver an authentic dermatology.
            We are clinically oriented in catering to several services in skin and hair health management.
          </p>
        </div>

        {/* EVENT GRID */}
        <div className="gallery-grid-wrapper">
          <div className="gallery-grid">
            {galleryEvents.map((event, index) => (
              <div
                key={index}
                className="gallery-event-card"
                onClick={() => {
                  setLightboxIndex(0);
                  setActiveEventIndex(index);
                }}
              >
                <div className="gallery-image-wrapper">
                  <img
                    src={event.images[0]}
                    alt={event.title}
                    className="gallery-bg-blur"
                  />
                  <img
                    src={event.images[0]}
                    alt={event.title}
                    className="gallery-main-img"
                  />
                </div>

                <div className="event-title">{event.title}</div>
              </div>
            ))}
          </div>
        </div>

        {/* VIDEO CAROUSEL */}
        <div className="videos-section">
          <div className="video-carousel-wrapper">
            <button
              className="video-arrow"
              onClick={() =>
                setVideoIndex((prev) =>
                  prev === 0 ? featureCards.length - videosToShow : prev - 1
                )
              }
            >
              ‹
            </button>

            <div className="video-carousel-track">
              {featureCards
                .slice(videoIndex, videoIndex + videosToShow)
                .map((c, i) => (
                  <div
                    key={i}
                    className="video-card"
                    onClick={() => openVideo(c.video)}
                  >
                    <div className="video-vertical">
                      <img src={c.img} alt="Video" />
                      <div className="video-play-icon">▶</div>
                    </div>
                  </div>
                ))}
            </div>

            <button
              className="video-arrow"
              onClick={() =>
                setVideoIndex((prev) =>
                  prev + videosToShow >= featureCards.length
                    ? 0
                    : prev + 1
                )
              }
            >
              ›
            </button>
          </div>
        </div>

        {/* LIGHTBOX */}
        {activeEventIndex !== null && (
          <div
            className="lightbox-overlay"
            onClick={() => setActiveEventIndex(null)}
          >
            <div
              className="lightbox-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="lightbox-close"
                onClick={() => setActiveEventIndex(null)}
              >
                ×
              </button>

              <h3 className="lightbox-event-title">
                {galleryEvents[activeEventIndex].title}
              </h3>

              <button
                className="lightbox-nav left"
                onClick={() =>
                  setLightboxIndex((prev) =>
                    prev === 0
                      ? galleryEvents[activeEventIndex].images.length - 1
                      : prev - 1
                  )
                }
              >
                ‹
              </button>
              {/* 
              <img
                className="lightbox-main-img"
                src={
                  galleryEvents[activeEventIndex].images[lightboxIndex]
                }
                alt="Event"
              /> */}
              {galleryEvents[activeEventIndex]?.images?.length > 0 && (
                <img
                  key={lightboxIndex}
                  className="lightbox-main-img"
                  src={
                    galleryEvents[activeEventIndex].images[lightboxIndex]
                  }
                  alt="Event"
                />
              )}

              <button
                className="lightbox-nav right"
                onClick={() =>
                  setLightboxIndex((prev) =>
                    prev ===
                      galleryEvents[activeEventIndex].images.length - 1
                      ? 0
                      : prev + 1
                  )
                }
              >
                ›
              </button>
            </div>
          </div>
        )}

        {/* VIDEO MODAL */}
        {videoModalSrc && (
          <div
            className="video-modal-overlay"
            onClick={closeVideo}
          >
            <div
              className="video-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button className="video-close" onClick={closeVideo}>
                ×
              </button>

              <video
                ref={videoRef}
                src={videoModalSrc}
                controls
                autoPlay
                className="video-player"
              />

              <button
                className="video-fullscreen-btn"
                onClick={makeVideoFullscreen}
              >
                Full Screen
              </button>
            </div>
          </div>
        )}
      </section>
    </>
  );
}
